<template>
  <div 
    class="material-box" 
    :style="{display: !isPageAllowed?'block':'flex'}"
    v-loading="mixinLoading"
  >
        <template v-if="isPageAllowed">
            <div class="material-left" :class="{state: optionBar}">
                <DataOption 
                    :conditionChecks.sync="conditionCheckList"
                    :dimensionChecks.sync="dimensionCheckList"
                    :fieldsChecks.sync="fieldsCheckList"
                    :dimensionList="dimensionList"
                    :fieldsList="fieldsList"
                    :fixed-state="fixedState"
                    :option-bar.sync="optionBar"
                    @fixed-change="handleFixedChange"
                />
            </div>
            <div 
                class="material-right"
                :class="{'fixed-height': tableSettingFormData.fixedHeight}"
            >
                <div class="material-right-query">
                    <DataQuery
                        :conditionCheckList="conditionCheckList"
                        :dimensionCheckList="dimensionCheckList"
                        :fieldsCheckList="fieldsCheckList"
                        :dimensionList="dimensionList"
                        :fieldsList="fieldsList"
                        :otherQueryParams="otherQueryParams"
                       
                    />
                </div>
                <div class="material-right-list" >
                    <DataList
                        :setting-form.sync= "tableSettingFormData"
                        :flatDimensionList="flatDimensionList"
                    />
                </div>
            </div>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>素材查询分析页面</p>
            </NoPermissionInfo>
        </template>
  </div>
</template>

<script>
/**
 * 指标
 */
import { pageMixin } from '@/views/mixins/pageMixin'
import DataOption from './components/dataOption'
import DataQuery from './components/dataQuery'
import DataList from './components/dataList'
import NoPermissionInfo from '@/components/noPermissionInfo';
import { conditionEditModal, dimensionEditModal, useTempModal, exportDataModal } from './modal'
import { cloneDeep } from 'lodash'
import dayjs from 'dayjs';
import { 
    DEFAULT_SELECT_MODAL_DATA, DEFAULT_SELECT_DATA, STOR_SELECT_DATA_KEY,
    DIMENSION_DATE_FORM, DEFAULT_DIMENSION_SORT_NUM, NUM_TYPE, DIMENSION_TYPE_DATA,
     DIMENSION_TYPE , DATE_TYPE, DIMENSION_FIELD_DATA,
     CONDITION_CONTENT_DIMENSION_FORM,
} from './constant'
import { 
    getMaterialConditionAreaStateApi,setMaterialConditionAreaStateApi,addAndUpdateMaterialTemplateApi,
    getMaterialTempApi,getDefMaterialTempApi, getMaterialListApi, getMaterialConditionListApi, getMaterialDisableDateApi,
    downloadMaterialNoWatermarkApi,downloadMaterialWatermarkApi
} from '@/api';
import { iframeDownloadFile } from '@/utils'
import { validNum } from '@/utils/validate'
import utils from '@/libs/utils'
const defaultTableData= ()=>( { field_list: [], list: [] });//空表格数据

export default {
    mixins: [ pageMixin ],
    components: { DataOption, DataQuery, DataList, NoPermissionInfo },
    provide() {
        return {
            updataCheckList:        (...args)=> this.updataCheckList(...args),          //更新选中的书怒
            conditionModal:         (...args)=> this.showConditionModal(...args),       //筛选 编辑
            updataCheck:            (...args)=> this.handleCheckChange(...args),        //拖拽跟新选中
            editDimension:          (...args)=> this.handleEditDimension(...args),      //编辑维度
            resetSelectData:        ()=>        this.resetSelectData(),                 //重置数据
            copyPage:               ()=>        this.handleCopyPage(),                  //复制页面
            useTempModal:           (...args)=> this.handleUseTempModal(...args),       //使用模板
            getFieldData:           ()=>        this.fieldData,                         //获取指标对象数据
            getDimensionData:       ()=>        this.dimensionData,                     //获取维度对象数据
            addTempData:            (...args)=> this.addTempData(...args),              //添加模板
            defaultParams:                      this.defaultParams,                     //默认参数
            loadingData:                        this.loadingData,                       //loading数据  必须传对象
            queryList:              (...args)=> this.handleQueryList(...args),          //查询
            exportList:             (...args)=> this.handleExportList(...args),         //导出
            updataOtherQueryParams: (...args)=> this.updataOtherQueryParams(...args),   //更新其他查询参数
            global:                             this,                             //所有数据
            currentChange:          (...args)=> this.handleCurrentChange(...args),      //分页  当前页切换
            addCondition:           (...args)=> this.handleAddCondition(...args),       //添加维度
            getDisableDate:         (...args)=> this.getDisableDate(...args),           //获取禁用日期
            secondCondition:        (...args)=> this.handleSecondCondition(...args),    //二次筛选
            sortChange:             (...args)=> this.handleSortChange(...args),         //排序
        }
    },
    data() {
        const date = new Date();
        return {
            defaultParams: {
                plat_id: 0,//媒体id
            },
            conditionCheckList: [],
            dimensionCheckList: [],
            fieldsCheckList: [],
            tableSettingFormData: {
                fixedHeight: true,//固定高度
                showAllSummary: true,//总-汇总数据
                showDaySummary: false,//日-汇总数据
            },
            fixedState: true,
            optionBar: true,
            otherQueryParams: {
                range_time: [ 
                    dayjs(date.getTime() - 3600 * 1000 * 24).format('YYYY-MM-DD'), 
                    dayjs(date.getTime() - 3600 * 1000 * 24).format('YYYY-MM-DD')  
                ],
                dimension_default_sort: '1', // 0  1
                default_display_range: '1',
                quick_date: ''
            },
            cacheParamsData: "{}",//缓存查询参数  再次使用
            loadingData: {
                exportLoading: false,
                listLoading: false,
                conditionLoading: '',//字段名
                dateLoading: false,
                downloadLoading: false
            },
            materialData: defaultTableData(), //报表的所有数据 { field_list: [], list: [] }
            pageSize: 100,// 每页条数
            pageNum: 1,//当前页
            startDate: '',//起始日期
            defaultDisabledDate: {}, //默认的限制日期
            // dimensionList: dimensionList,
            // fieldsList: fieldsList,
        }
    },
    computed: {
        fieldsList() {
            return this.rawFields.map(item=> {
				return {
					...item,
					children: item.children.map(item=> {
						return {
							...item,
							config: this.parseJson(item.config, item)
						}
					})
				}
			})
        },
        dimensionList() {
            return this.pageDimension.map(item=> {
                const p = item;
				return {
					...item,
					children: item.children.map(item=> {
                        // console.log(`${p.display_name}-${item.display_name}`, item.name);
                        
						return {
							...item,
							config: this.parseJson(item.config, item)
						}
					})
				}
			})
        },
        flatDimensionList() {
            return this.dimensionList.reduce((pre,item)=>{
                pre = [].concat(pre, item.children);
                return pre;
            },[])
        },
        flatFieldsList() {
            return this.fieldsList.reduce((pre,item)=>{
                pre = [].concat(pre, item.children);
                return pre;
            },[])
        },
        fieldData() {
            return this.flatFieldsList.reduce((pre, item)=> {
                pre[item.name] = item;
                return pre;
            }, {})
        },
        dimensionData() {
            return this.flatDimensionList.reduce((pre, item)=> {
                pre[item.name] = item;
                return pre;
            }, {})
        }
    },
    created() {
        // 收起菜单栏
        this.$store.dispatch('app/closeSideBar', {withoutAnimation: false});
        this.getConditionAreaState()
    },
    methods: {
        // 导出数据
        async handleExportList() {
            if (!this.fieldsCheckList.length) {
                this.$message.error('请至少选择一个数据指标')
                return;
            }
            const [ params, replaceDimensionData ] = this.getParamsData();
            // this.cacheParamsData = JSON.stringify(params);
            replaceDimensionData.forEach(dimension=> {
                this.handleCheckChange('replace', 'dimensionCheckList', cloneDeep(dimension));
            });
            try {
                this.loadingData.exportLoading = true
                const { data } = await getMaterialListApi(Object.assign({}, params, {
                    return_filename: '1',
                }));
                const filename = data.filename;
                const onSubmit = async (filename)=> {
                    const result = await getMaterialListApi(Object.assign({}, params, {
                        export_filename: filename,
                        export_type: '1'
                    }));
                    this.$message.success(result.info)
                    vm.close()
                }
                const { vm } = exportDataModal({
                    props: {
                        filename
                    },
                    cbs: { onSubmit }
                })
            } catch (error) {
                this.$message.error(error.info || error.message)
            }finally {
                this.loadingData.exportLoading = false
            }
        },
        // 查询操作
        handleQueryList() {
            if (!this.fieldsCheckList.length) {
                this.$message.error('请至少选择一个数据指标')
                return;
            }
            const [ params, replaceDimensionData ] = this.getParamsData();
            this.cacheParamsData = JSON.stringify(params);
            replaceDimensionData.forEach(dimension=> {
                this.handleCheckChange('replace', 'dimensionCheckList', cloneDeep(dimension));
            });
            if (!this.fixedState) {
                this.optionBar = false
            };
           
            this.pageNum = 1;
            this.getList(true);
        },
        // 整合查询参数
        getParamsData() {
            const replaceDimensionData = [];
            const { dimension_default_sort, range_time, default_display_range, quick_date } = this.otherQueryParams;
            const [ firstField ] = this.fieldsCheckList;
            const { exclude_condition_fields, condition } = this.getConditionParams();
            let sortDefaultNum = (this.dimensionCheckList.filter(v=>v.modalData && v.modalData.order_by)).length;
            const group = this.dimensionCheckList.map((item,index)=> {
                const { modalData } = item;
                const data = { group_by:  item.name };
                if(modalData && modalData.order_by) {
                    if (DIMENSION_DATE_FORM.includes(item.name)) {
                        const { sum_type, order_by, order_type } = modalData;
                        Object.assign(data, { sum_type, order_by, order_type })
                    }else {
                        const { order_by, order_type, show_num, show_type  } = modalData;
                        Object.assign(data, { order_by, order_type, show_num, show_type })
                    };
                }else if(!!+dimension_default_sort && DEFAULT_DIMENSION_SORT_NUM > index && sortDefaultNum < DEFAULT_DIMENSION_SORT_NUM) {
                    sortDefaultNum ++;
                    const newData = {
                        order_by: firstField.name,
                        order_type: 'desc',
                        show_type: NUM_TYPE.All,
                        show_num: null,
                    };
                    if (modalData) {
                        Object.assign(newData, modalData)
                    }
                    replaceDimensionData.push({
                        ...item,
                        modalData: newData,
                    });
                    Object.assign(data, newData);
                }else {
                    Object.assign(data, {
                        order_by: '',
                        order_type: '',
                        show_type: '',
                        show_num: null,
                    });
                };
                if (modalData && modalData.dimension) {
                    Object.assign(data, { 
                        [`${item.name}_dimension`]: modalData.dimension
                    });
                }
                return data;
            });
            const field = this.fieldsCheckList.map(v=>v.name)
            const params = {
                condition: JSON.stringify(condition),
                exclude_condition_fields: exclude_condition_fields.toString(),
                group: JSON.stringify(group),
                field: JSON.stringify(field),
                range_time: range_time.join('/'),
                default_display_range,
                quick_date
            };
            return [ params, replaceDimensionData ];
        },
        // 处理二次筛选
        async handleSecondCondition(data, remove = false) {
            const paramsData = JSON.parse(this.cacheParamsData);
            const { field } = data;
            const whereList = paramsData.where || [];
            const index = whereList.findIndex(item=> item.field === field );
            if (remove) {
                if (index > -1) {
                    whereList.splice(index, 1)
                }
            }else {
                if (index > -1) {
                    whereList.splice(index, 1, data)
                }else {
                    whereList.push(data)
                };
            }
            paramsData.where = whereList;
            this.cacheParamsData = JSON.stringify(paramsData);
            this.pageNum = 1;
            this.getList();
        },
        // 获取数据列表
        async getList(isQuery = false) {
            const params = JSON.parse(this.cacheParamsData);
            try {
                this.loadingData.listLoading = true;
                if (isQuery) {
                    this.materialData = defaultTableData();
                }
                const { data } = await getMaterialListApi(Object.assign({}, params, {
                    pn: this.pageNum,
                    rn: this.pageSize,
                }));
                const { field_list, list, total, totalCnt, file_name } = data;
                
                // 查询按钮
                if (isQuery && !data.list.length) {
                    this.materialData = defaultTableData();
                    this.$message.error('所选筛选在该日期内无任何数据')
                    return
                }
                if ( !isQuery) {
                    Object.assign(this.materialData, { 
                        totalCnt: data.totalCnt,
                        total: data.total,
                        list: Object.freeze(this.formatTableData(data, params.group)),
                    })
                }else {
                    this.materialData = {
                        field_list, total, totalCnt, file_name,
                        list: Object.freeze(this.formatTableData(data,  params.group))
                    };
                }
            } catch (error) {
                console.log("查询出错", error);
                if(error.data&&error.data.length>0){
                    let htmlStr = '<div class="tal" style="max-height: 300px;overflow: auto;">';
                    error.data.forEach(item=>{
                        htmlStr += `<p class="text-bold tal">${item.err_title}</p>`;
                        if(item.err_msg&&item.err_msg.length>0){
                            item.err_msg.forEach(error=>{
                                htmlStr += `<p class="tal">${error}</p>`;
                            })
                        }
                    });
                    htmlStr +='</div>';
                    this.$confirm(htmlStr, error.info||'查询错误', {
                        showCancelButton: false,
                        confirmButtonText: '我知道了',
                        type: 'error',
                        center: true,
                        dangerouslyUseHTMLString: true,
                        showClose: false,
                        distinguishCancelAndClose: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                    });
                }else {
                    this.$message.error(error.info || error.message)
                }
                
            }finally {
              setTimeout(()=> {
                this.loadingData.listLoading = false;
              }, 1000)
            }
        },
        formatTableData({ list, total }, group) {
            if (!list.length) {
                return []
            }
            const sumData = {
                total,
            }
            const type = { total: '总-汇总', 'avg': '总-日均' }
            const firstList = [ 'total', 'avg'].map(key => {
                const data = sumData[key];
                return data ? { ...data, type: 'sum', index: type[key] } : null;
            }).filter(v => !!v);
            const nList = firstList.map(v => this.formatNum(v))
                .concat(
                    list.map((v, index) => {
                        return {
                            ...this.formatNum(v),
                            index: index + 1,
                            id: utils.randomString(20)
                        }
                    })
                );
            if (this.tableSettingFormData.showAllSummary && !!(group && group.length)) {
                return nList
            }else {
                return nList.filter(row=> row.type !== 'sum')
            }
             
        },
        formatNum(v) {
            const dimensionData = this.dimensionData;
            return Object.keys(v).reduce((pre, item) => {
                if (validNum(v[item]) && +v[item] >= 1000&&!dimensionData[item]) {
                    pre[item] = v[item].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    pre[`_${item}`] = v[item]
                } else {
                    pre[item] = v[item];
                };
                return pre;
            }, {})
        },
        // 排序
        handleSortChange( { prop, order }) { 
            const paramsData = JSON.parse(this.cacheParamsData);
            Object.assign(paramsData, {
                order_by: prop,
                order_type: order=='descending'?'desc':order=='ascending'?'asc':''
            })
            this.cacheParamsData = JSON.stringify(paramsData);
            this.pageNum = 1;
            this.getList();
        },
        parseJson(json, item) {
			try {
				return JSON.parse((json || "{}"));
			} catch (error) {
				console.log('json解析失败',item.name, item.display_name);
				return {}
			}
		},
        initPageStates() {
            this.getConfigData()
        },
        async getConfigData() {
           this.setDefaultSelectData()
           this.getDefaultDisabledDate()
        },
         // 默认禁用日期
        async getDefaultDisabledDate() {
            const disabledDate = await this.getDisableDate();
            this.defaultDisabledDate = Object.freeze(disabledDate);
            this.startDate = disabledDate.start_date;
        },
        // 复制页面
        handleCopyPage() {
            window.localStorage.setItem(STOR_SELECT_DATA_KEY, JSON.stringify({
                conditionCheckList: this.conditionCheckList,
                dimensionCheckList: this.dimensionCheckList,
                fieldsCheckList: this.fieldsCheckList,
                otherQueryParams: this.otherQueryParams
            }));
            window.open(window.location.href)
        },
        // 设置默认值
        async setDefaultSelectData(def_temp = false) {
            const defaultDataJson = window.localStorage.getItem(STOR_SELECT_DATA_KEY)
            if (defaultDataJson) {
                const defaultData = JSON.parse(defaultDataJson);
                Object.assign(this, defaultData);
                window.localStorage.removeItem(STOR_SELECT_DATA_KEY);
            }else {
                if (!def_temp) {
                    const { data } = await getDefMaterialTempApi({ ...this.defaultParams });
                    if (data.info) {
                        const tempData = await this.getMaterialTemp(data.info.id);
                        Object.assign(this, await this.formatTempData(tempData));
                        await this.$nextTick();
                        this.handleQueryList();
                        return;
                    }
                };
                const cacheCbData = { };
                const listKeys = Object.keys(DEFAULT_SELECT_DATA);
                [ ].concat(this.flatDimensionList, this.flatFieldsList)
                .forEach(item=> {
                    listKeys.forEach(key=> {
                        if (DEFAULT_SELECT_DATA[key].includes(item.name)) {
                            cacheCbData[`${key}${item.name}`] = ()=>this.handleCheckChange(true, key,  cloneDeep(item));
                        }
                    })
                });
                // 按照顺序添加数据
                listKeys.forEach(key=> {
                    DEFAULT_SELECT_DATA[key].forEach(name=> {
                        const cb = cacheCbData[`${key}${name}`];
                        cb && cb()
                    })
                });
            }
            
        },
        updataCheckList(updataName, list) {
            this[updataName] = list;
        },
        // 刷选选择
        showConditionModal(dimensionData, callback) {
            const onSubmit = (data, remove)=> {
                if (remove) {
                    // 如果条件列表为空  直接删除
                    this.handleCheckChange(false, 'conditionCheckList',dimensionData);
                }else {
                    callback(data)
                }
                vm.close()
            };
            const { vm } = conditionEditModal({
				props: {
					title: dimensionData.display_name,
                    dimension: dimensionData,
                    fieldData: this.fieldData,
                    conditionParams:  this.getConditionParams(),
                    range_time: this.otherQueryParams.range_time.join('/'),
                    defaultParams: this.defaultParams,
				},
                cbs: {
                    onSubmit,
                    getDisableDate: this.getDisableDate
                }
            })
        },
        handleCheckChange(check, checkName, data, isFirst = false) {
            Promise.resolve().then(()=> {
                if (checkName ==='conditionCheckList') {
                    this.getDefaultDisabledDate()
                }
            })
            // 替换
            if ('replace' === check) {
                const index =  this[checkName].findIndex(item=> item.name === data.name);
                if (index > -1) {
                    this[checkName].splice(index, 1, this.setSubText(checkName, data) );
                    return
                }
                // 继续执行添加的操作
            };
            let hasFirstData = false
            if (isFirst) {
               hasFirstData = !!this[checkName].find(v=>v.name === data.name);
            }
            if (!Array.isArray(data)) {
                data = [ data ];
            };
            if (check) {
                const names = this[checkName].map(v=>v.name);
                const filterList = data.filter(item=> !names.includes(item.name));
                this[checkName] = [].concat(
                    this[checkName], 
                    filterList.map(item=> {
                        const defaultData = DEFAULT_SELECT_MODAL_DATA[`${checkName}_${item.name}`];
                        // getConditionSubText
                        // getDimensionSubText
                        if (defaultData && !item.modalData) {
                            // 添加默认值
                            return  this.setSubText(checkName,{
                               ...item,
                                modalData: cloneDeep(defaultData)
                            }) 
                        }else {
                            return this.setSubText(checkName,item) ;
                        }
                    })
                );
            }else {
                const names = data.map(v=>v.name);
                this[checkName] = this[checkName].filter(item=> !names.includes(item.name))
            };
            
            // 添加为第一维度
            if (isFirst) {
                if ( data.length === 1) {
                    const [ firstData ] = data;
                    const index = this[checkName].findIndex(v=>v.name === firstData.name);
                    if (index > -1) {
                        const unCheckList = [];
                        for(let i = 0; i<index; i++) {
                            unCheckList.push(this[checkName][i]);
                        }
                        const addData = this[checkName][index];
                        this[checkName].splice(index, 1);
                        this[checkName] = [ addData, ...this[checkName]];

                        if (unCheckList.length && hasFirstData) {
                            this.handleCheckChange(false, checkName, unCheckList )
                        }
                    };
                }else {
                    console.error('多条数据不能调整位置', data);
                }
            };
        },
        // 编辑维度
        handleEditDimension(dimension) {
            const onSubmit = (data)=> {
                this.handleCheckChange('replace', 'dimensionCheckList', cloneDeep({
                    ...dimension,
                    modalData: data
                }));
                vm.close()
            }
            const { vm } = dimensionEditModal({
                title: dimension.display_name,
                props: {
                    dimension,
                    fieldsCheckList: this.fieldsCheckList,
                    flatFieldsList: this.flatFieldsList,
                    fieldData: this.fieldData
                },
                cbs: {
                    onSubmit
                }
            })
        },
        // 重置数据
        resetSelectData() {
            this.conditionCheckList = [];
            this.dimensionCheckList = [];
            this.fieldsCheckList = [];
            this.setDefaultSelectData(true)
        },
        // 使用模版提示
        async formatTempData(tempData, message = '以下已选条件无权限，已自动剔除') {
            await new Promise((resolve,reject)=> {
                const { condition_config, dimension_config, field_config } = tempData.error;
                if (condition_config.length || dimension_config.length || field_config.length ) {
                    let conditionHtml = condition_config.length > 0 ? '<p class="pb6"><span class="text-bold">筛选条件：</span>' + condition_config.join('，') + '</p>' : '';
                    let dimensionHtml = dimension_config.length > 0 ? '<p class="pb6"><span class="text-bold">维度分组：</span>' + dimension_config.join('，') + '</p>' : '';
                    let fieldHtml = field_config.length > 0 ? '<p class="pb6"><span class="text-bold">数据指标：</span>' + field_config.join('，') + '</p>' : '';
                    let htmlStr = `<div class="tal" style="max-height: 300px;overflow: auto;">${conditionHtml}${dimensionHtml}${fieldHtml}</div>`;
                    this.$confirm(htmlStr, message, {
                        showCancelButton: false,
                        confirmButtonText: '我知道了',
                        type: 'error',
                        center: true,
                        dangerouslyUseHTMLString: true,
                        showClose: false,
                        distinguishCancelAndClose: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                    }).then(() => {
                        resolve();
                    });
                }else {
                    resolve()
                }
            });
            const { dimension_config=[], field_config=[], condition_config=[], other_config=[] } = tempData.info || {};
            const fieldData = this.fieldData;
            const dimensionData = this.dimensionData;
            const conditionCheckList = condition_config.map(item=> {
                const data = {
                    ...item,
                    ...dimensionData[item.name],
                   
                };
                const isExclude = item.modalData.isExclude;
                if (isExclude) {
                    data.modalData.isExclude = JSON.parse(isExclude)
                }
                return this.setSubText('conditionCheckList', data) 
            });
            const dimensionCheckList = dimension_config.map(item=> {
                return this.setSubText('dimensionCheckList', {
                    ...item,
                    ...dimensionData[item.name]
                }) 
            });
            const fieldsCheckList = field_config.map(item=> {
                return {
                    ...item,
                    ...fieldData[item.name]
                }
            });
            return {
                conditionCheckList, dimensionCheckList, fieldsCheckList,
                otherQueryParams: Object.assign({}, this.otherQueryParams, other_config)
            }
        },
        // 使用模版
        handleUseTempModal(util) {
            const onSubmit = async (data)=> {
                const tempData = await this.getMaterialTemp(data.id);
                Object.assign(this, await this.formatTempData(tempData));
                vm.close()
            }
            const { vm } = useTempModal({
                props: {
                    defaultParams: this.defaultParams,
                    util,
                },
                cbs: {
                    onSubmit
                }
            })
        },
        // 获取固定状态
        async getConditionAreaState() {
            const { data } = await getMaterialConditionAreaStateApi();
            this.fixedState = !!data.state;
        },
        // 设置固定状态
        async handleFixedChange(state) {
            const params = {
                state: +state
            }
            try {
                await setMaterialConditionAreaStateApi(params);
                this.fixedState = state;
            } catch (error) {
                console.log('设置状态错误', error);
            }
        },
        // 添加模板
        async addTempData(name, otherParams) {
            try {
                const condition_config = this.conditionCheckList.map(item=> {
                    const { name, display_name, modalData } = item;
                    return {
                        name,display_name,
                        modalData,
                        dimension: modalData.dimension,
                    }
                });
                const dimension_config = this.dimensionCheckList.map(item=> {
                    const { name, display_name, modalData = {} } = item;
                    return {
                       modalData,
                       dimension: modalData.dimension,
                       name, display_name
                    }
                });
                const field_config = this.fieldsCheckList.map(item=> {
                    const { name, display_name } = item;
                    return {
                         name, display_name 
                    }
                })
                const { default_display_range, dimension_default_sort } = this.otherQueryParams;
                const params = {
                    ...this.defaultParams,
                    ...otherParams,
                    name,
                    condition_config,
                    dimension_config,
                    field_config,
                    other_config: {
                        default_display_range,
                        dimension_default_sort
                    }
                }
                const result = await addAndUpdateMaterialTemplateApi(params);
                this.$message.success(result.info || '操作成功');
            } catch (error) {
                if (error?.data?.error) {
                    this.formatTempData(error.data, '以下已选条件无权限，保存失败')
                }else {
                    this.$message.error(error.info || error.message);
                }
                console.log('保存模板失败', error);
            }
        },
        // 获取模板数据
        async getMaterialTemp(id) {
            const params = {
                ...this.defaultParams,
                id
            }
            const { data } = await getMaterialTempApi(params);
            return data
        },
        // 更新其它查询参数  日期更多配置等
        updataOtherQueryParams(key, value) {
            Object.assign(this.otherQueryParams, {
                [key]: value
            })
        },
        // 获取筛选的参数格式
        getConditionParams() {
             const { exclude_condition_fields, condition } = this.conditionCheckList.reduce((pre, item)=> {
                const { modalData } = item;
                if (modalData) {
                    const { isExclude, list, dimension , range_time } = modalData;
                    if (isExclude) {
                        pre.exclude_condition_fields.push(item.name)
                    };
                    if (list) {
                        pre.condition[item.name] = list.map(v=>v.id)
                    };
                    if (dimension) {
                         pre.condition[`${item.name}_dimension`] = dimension;
                    }
                    if (range_time) {
                        pre.condition[item.name] = range_time.join('/')
                    }
                };
                return pre;
            }, { exclude_condition_fields: [], condition: {  } });
            return {
                exclude_condition_fields, condition
            }
        },
        // 切换当前页
        handleCurrentChange(val) {
            this.pageNum = val;
            this.getList()
        },
        // 添加维度
        async handleAddCondition(isFirst, field, text) {
           
            try {
                // 数据日期特殊处理
                if (DIMENSION_DATE_FORM.includes(field)) {
                    const selectDate = dayjs(text).format('YYYY-MM-DD');
                    this.updataOtherQueryParams('range_time', [ selectDate,  selectDate])
                }else {
                    const { exclude_condition_fields, condition } = this.getConditionParams();
                    const params = {
                        ...this.defaultParams,
                        return_condition: field,
                        exclude_condition_fields,
                        condition,
                        range_time: this.otherQueryParams.range_time.join('/'),
                        search: text,
                    };
                    let checkConditionData = this.conditionCheckList.find(item=> {
                        return item.name === field;
                    });
                
                    if (checkConditionData) {
                        const { modalData , config} = checkConditionData;
                        console.log(checkConditionData, 'checkConditionData');
                        // 如果是日期  直接往下走
                        if (modalData.list) {
                            if (config?.multiple_search === 'true') {
                                const nameList = text.split('，');
                                const fieldData = modalData.list.filter(v=>nameList.includes(v.name));
                                if (fieldData.length) {
                                    throw new Error(`${checkConditionData.display_name}中已存在【${fieldData.map(v=>v.name).join('，')}】`)
                                }
                            }else {
                                const fieldData = modalData.list.find(v=>v.name === text);
                                if (fieldData) {
                                    throw new Error(`${checkConditionData.display_name}中已存在${text}`)
                                }
                            }
                           
                        }
                    }else {
                        checkConditionData = cloneDeep(this.dimensionData[field]);
                        const defaultData = DEFAULT_SELECT_MODAL_DATA[`conditionCheckList_${field}`];
                        if (defaultData) {
                            checkConditionData.modalData = defaultData;
                        };
                        
                        
                    }
                    if (Object.keys(DIMENSION_TYPE_DATA).includes(field)) {
                        // 筛选需要和维度的 类型保持一致
                        const dimensionData = this.dimensionCheckList.find(item=> {
                            return item.name === field;
                        });
                        const dimensioType = dimensionData.modalData.dimension;
                        const checkDimension = checkConditionData.modalData.dimension
                        if (checkDimension !== dimensioType) {
                            checkConditionData.modalData.list = []
                        }
                        checkConditionData.modalData.dimension = dimensioType;
                    }
                    this.loadingData.conditionLoading = field;
                    const dimensionName = checkConditionData.modalData?.dimension;
                    // 如果有维度 要重新构建 return_condition 参数
                    if (dimensionName) {
                        params.return_condition = `${field}|${dimensionName}`;
                    }
                    const { data } = await getMaterialConditionListApi(params);
                    if (Array.isArray(data.list)) {
                        let list = [];
                        // 多个数据需要切割后添加
                        if (checkConditionData.config?.multiple_search === 'true') {
                            const nameList = text.split('，');
                            list = data.list.filter(item=> nameList.includes(item.name))
                        }else {
                            list = data.list.filter(item=> item.name === text)
                        }
                        if (list.length) {
                            this.handleCheckChange('replace', 'conditionCheckList', cloneDeep({
                                ...checkConditionData,
                                modalData: {
                                    ...(checkConditionData.modalData || {}),
                                    list: [ ...(checkConditionData.modalData?.list || []),  ...list]
                                }
                            }))
                        }else {
                            this.$message.error('所选筛选在该日期无任何数据');
                        }
                    // 处理日期
                    }else {
                        const selectDate = dayjs(text).format('YYYY-MM-DD');
                        const list = (data.list?.has_cost_date ||[]).filter(date=> {
                            return dayjs(date).format('YYYY-MM-DD') === selectDate;
                        });
                        if (list.length) {
                            this.handleCheckChange('replace', 'conditionCheckList', cloneDeep({
                                    ...checkConditionData,
                                    modalData: {
                                        ...(checkConditionData.modalData || {}),
                                        range_time: [ selectDate,  selectDate]
                                    }
                                }))
                        }else {
                            this.$message.error('所选筛选在该日期无任何数据');
                        }
                    }  
                }
               
                if (isFirst) {
                    const dimensionData = cloneDeep(this.dimensionData[field]);
                    this.handleCheckChange(true, 'dimensionCheckList', dimensionData, true)
                }
            } catch (error) {
                this.$message.error(error.info || error.message)
            }finally {
                this.loadingData.conditionLoading = ''
            }
        },
        // 获取禁用日期
        async getDisableDate(defaultParams = {}) {
            try {
                this.$bus.$emit('resetDisableDate')
                this.loadingData.dateLoading = true
                const { exclude_condition_fields, condition } = this.getConditionParams();
                const params = {
                    ...defaultParams,
                    exclude_condition_fields, condition,
                }
                const { data } = await getMaterialDisableDateApi(params);
                return data;
            } catch (error) {
                this.$message.error(error.info || error.message);
                return Promise.reject(error);
            }finally {
                this.loadingData.dateLoading = false
            }
        },
        // 下载无水印素材
        async downloadMaterialNoWatermark(path_url) {
            try {
                this.loadingData.downloadLoading = true;
                const params = {
                    path_url,
                };
                const { data } = await downloadMaterialNoWatermarkApi(params);
                iframeDownloadFile(data.path)
            } catch (error) {
                this.$message.error(error.info || error.message)
            }finally {
                this.loadingData.downloadLoading = false;
            }
        },
        // 下载水印素材
        async downloadMaterialWatermark(path_url) {
            try {
                this.loadingData.downloadLoading = true;
                const params = {
                    path_url,
                }
                const { data } = await downloadMaterialWatermarkApi(params);
                iframeDownloadFile(data.path)
            } catch (error) {
                this.$message.error(error.info || error.message)
            }finally {
                this.loadingData.downloadLoading = false;
            }
        },
        // 清除表格数据
        clearTabelData() {
            this.materialData = defaultTableData();
            this.pageNum = 1;
        },
        // 下载报表数据
        async downloadTableData() {
            const onSubmit = async (filename)=> {
                const params = JSON.parse(this.cacheParamsData);
                const result = await getMaterialListApi(Object.assign({}, params, {
                    export_filename: filename,
                    export_type: '2'
                }));
                this.$message.success(result.info)
                vm.close();
            }
            const { vm } = exportDataModal({
                props: {
                    filename: this.materialData.file_name
                },
                cbs: { onSubmit }
            })
        },
        getConditionSubText( item ) {
            const data =item.modalData;
            if (!data) {
                return ''
            };
            const dimensionData = this.dimensionData;
            const type = dimensionData[item.name].config.type;
            switch (true) {
                case DIMENSION_TYPE.CONTENT === type:
                case CONDITION_CONTENT_DIMENSION_FORM.includes(item.name):
                    const state = data.isExclude ? '(排除)' : '(包含)';
                    let desc ='';
                    if (data.list.length === 1) {
                        desc = data.list.map(v=>v.name).toString()
                    }else {
                        desc = data.list.length
                    };
                    if (CONDITION_CONTENT_DIMENSION_FORM.includes(item.name)) {
                        return `${DIMENSION_TYPE_DATA[item.name][data.dimension]}/${state} ${desc}`
                    }else {
                        return `${state} ${desc}`
                    }
                case DIMENSION_TYPE.DATE_SELECT === type:
                    const { range_time, dimension } = data
                    return `${ DIMENSION_TYPE_DATA[item.name][dimension]} ${range_time.join('~')}`
                case DIMENSION_TYPE.DATE  === type:
                    return data.range_time.join('~')
                default:
                    return '';
            }
                   
        },
        getDimensionSubText(dimension) {
            const modalData = dimension.modalData;
            if (!modalData) {
                return ''
            }
            const order = {
                desc: '降序',
                asc: '升序',
            };
            const fieldData =  Object.assign({}, DIMENSION_FIELD_DATA, this.fieldData);
            let sub_text = ''
            if (DIMENSION_DATE_FORM.includes(dimension.name)) {
                const { order_by, order_type, sum_type } = modalData;
                const field = fieldData[order_by] || {};
                sub_text += `${DATE_TYPE[sum_type]}/${field.display_name}${order[order_type]}`;
            }else {
                const { order_by, order_type, show_num } = modalData;
                if (order_by) {
                    const field = fieldData[order_by] || {};
                    let show_num_text = show_num? `展示${show_num}`: '全部展示';
                    sub_text += `${ field.display_name }${order[order_type]}/${show_num_text}`;
                };
            };
            return `${modalData.dimension? DIMENSION_TYPE_DATA[dimension.name][modalData.dimension]  + (sub_text&&'/' || '')  : ''}${sub_text}`
        },
        setSubText(checkName, data) {
            const modalData = data.modalData;
            if (!modalData) {
                return data
            };
            if (checkName === 'conditionCheckList') {
                const sub_text = this.getConditionSubText( data);
                return Object.assign({}, data, {
                    sub_text,
                    title: `${data.display_name}:${sub_text}`
                } )
            }
            if (checkName === 'dimensionCheckList') {
                const sub_text = this.getDimensionSubText(data, modalData)
                return Object.assign({}, data, {
                    sub_text,
                    title: `${data.display_name}:${sub_text}`
                })
            }
            return data;
        }
    }
}
</script>

<style lang="scss" scoped>
.material-box {
    height: calc(100vh - 50px);
    min-height: 600px;
    display: flex;
    background-color: #f8f8f9;
    .material {
        &-left{
            height: 100%;
            width: 24px;
            // transition: width 0.2s;
            &.state {
                width: 300px;
            }
        }
        &-right {
            flex: 1 1 0;
            // background: green;
            height: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            &.fixed-height {
                display: flex;
                flex-direction: column;
            }
            &-list {
                margin-top: 12px;
                flex: 1 1 0;
            }
        }
    }
}
</style>